import socketHost from '../utils/socketHost';
import { socketRes } from '../api/api';

export default class SocketServer {
    // 定义单例(单个实例)模式
    static instance = null
    static get Instance() {
        if (!this.instance) {//防止创建多个实例对象
            this.instance = new SocketServer()
        }
        return this.instance;
    }
    // 和服务端连接的socket对象
    ws = null
    // 存储回调函数
    callBackMapping = {}
    // 标识是否连接成功
    connection = false
    // 记录重试的次数
    sendRetryCount = 0;
    // 重新连接尝试的次数
    connectRetryCount = 0;
    // 心跳定时器
    heartbeatInterval = 0;
    // 定义连接服务器的方法
    connect() {
        // 连接服务器
        if (typeof(window) == 'undefined') {
            return;
            //return console.log("服务端不支持window WebSocket");
        }
        if (!window.WebSocket) { 
            return;
            //return console.log('您的浏览器不支持WebSocket') 
        }
        this.ws = new WebSocket(socketHost()) // 链接地址
        // 连接成功的事件
        this.ws.onopen = () => {
            console.log("连接socket成功")
            this.connection = true;
            this.startHeartbeat();
            // 重置重新连接的次数
            this.connectRetryCount = 0
        }
        // 失败有两种情况：1.本身连接服务器失败2.连接成功后，关闭了服务器
        this.ws.onclose = () => {
            console.log('连接关闭')
            this.connection = false;
            this.stopHeartbeat(); // WebSocket连接关闭时，停止心跳检测
            if(this.connectRetryCount < 10){
                this.connectRetryCount++;
            }else{
                this.connectRetryCount = 2*60*10;
            }
            setTimeout(() => {
                this.connect()
                if(this.callBackMapping['FootballListReconnect']){
                    this.callBackMapping['FootballListReconnect'].call(this)
                }
            }, 500 * this.connectRetryCount)
        }
        // 得到服务端发送过来的数据
        // 使用箭头函数不会改变callback的this，使callback的this指向vm
        this.ws.onmessage = evt => {
            // 真正服务端发送过来的原始数据时在msg中的data字段
            //let data = JSON.parse(msg.data)
            //let socketType = data.tag
            // 判断回调函数是否存在
            // 根据页面传递的值进行判断
            //this.callBackMapping[socketType].call(this,data)
            // if (socketType == "refreshFirst") {
            //     let realData = data.data
            //     this.callBackMapping[socketType].call(this,realData)
            // }
            // else if (socketType == "refreshSecond") {
            //     this.callBackMapping[socketType].call(this,data)
            // }
            // else if (socketType == "refreshRoll") {
            //     this.callBackMapping[socketType].call(this,data)
            // }

            var that = this;
            //console.log("onMessage", evt);
            if (typeof evt.data == "string") {
                //console.log("收到socket服务消息，内容：", typeof evt.data, evt);
            } else {
                //console.log('解析前：',evt)
                var data = evt.data;
                var reader = new FileReader();
                reader.onload = function (e) {
                    // var buf = new Uint8Array(reader.result);
                    
                    // var modelResponse = protoRoot.lookupType("model.Response");
                    // var response = modelResponse.decode(buf);
                    var response = socketRes(reader.result)
                    //console.log('解析后：',response)

                    if (response.subType == 101) {
                        //比分
                        if(response.subTypeDetail == 1){
                            if(that.callBackMapping['FootballListUpdate']){
                                that.callBackMapping['FootballListUpdate'].call(this,response.data.value)
                            }
                            
                        }
                        //指数
                        if(response.subTypeDetail == 2){
                            if(that.callBackMapping['FootballListLuckUpdate']){
                                that.callBackMapping['FootballListLuckUpdate'].call(this,response.data.value)
                            }
                            
                        }
                    }
                    if (response.subType == 102) {
                        //某公司odds更新
                        if(that.callBackMapping['FootballComListUpdate']){
                            that.callBackMapping['FootballComListUpdate'].call(this,response.data.value)
                        }
                    }
                    if (response.subType == 111) {
                        //比分
                        if(response.subTypeDetail == 1){
                            if(that.callBackMapping['FootballMatchDetailUpdate']){
                                that.callBackMapping['FootballMatchDetailUpdate'].call(this, response.data.value);
                            }
                            
                        }
                        //名单 
                        if(response.subTypeDetail == 2){
                            if(that.callBackMapping['FootballMatchDetailGoalUpdate']){
                                that.callBackMapping['FootballMatchDetailGoalUpdate'].call(this,response.data.value)
                            }
                            
                        }
                        //指数 
                        if(response.subTypeDetail == 3){
                            if(that.callBackMapping['FootballMatchDetailLuckUpdate']){
                                that.callBackMapping['FootballMatchDetailLuckUpdate'].call(this,response.data.value)
                            }
                            
                        }
                    }
                    //事件统计
                    if (response.subType == 115) {
                        if(that.callBackMapping['FootballMatchStatsUpdate']){
                            that.callBackMapping['FootballMatchStatsUpdate'].call(this, response.data.value);
                        }
                        
                        
                    }
                    //事件统计
                    if (response.subType == 112) {
                        if(that.callBackMapping['FootballMatchEventUpdate']){
                            that.callBackMapping['FootballMatchEventUpdate'].call(this, response.data.value);
                        }
                       
                        
                    }
                    //积分版
                    if (response.subType == 113) {
                        if(that.callBackMapping['FootballMatchStandingUpdate']){
                            that.callBackMapping['FootballMatchStandingUpdate'].call(this, response.data.value);
                        }
                        
                        
                    }
                    //指数
                    if (response.subType == 114) {
                        if(that.callBackMapping['FootballMatchLuckUpdate']){
                            that.callBackMapping['FootballMatchLuckUpdate'].call(this, response.data.value);
                        }
                        
                    }
                    
                }
                reader.readAsArrayBuffer(data);
                //console.log("收到更新包内容：" + data);
                
                // reader.onload = function (e) {
                //     var buf = new Uint8Array(reader.result);
                //     protobuf.load("Common.proto", function (err, root) {
                //         var model = "model.Response";
                //         var p = root.lookupType(model);
                //         var dec = p.decode(buf);
                //         console.log(dec);
                //         if (dec.subType == 101) {
                //             //比分
                //             if(dec.subTypeDetail == 1){
                //                 readSxl(dec.data.value);
                //             }
                //             //指数
                //             if(dec.subTypeDetail == 2){
                //                 readSxlOdds(dec.data.value);
                //             }
                //         }
                //     });
                // }
                // reader.readAsArrayBuffer(data);
                // console.log("收到更新包内容：" + data);
            }
        }
        this.ws.onerror = function () {
            console.log('连接异常')
            this.connection = false;
            this.stopHeartbeat(); // WebSocket连接关闭时，停止心跳检测
        }
    }
    // 回调函数的注册
    registerCallBack(socketType, callBack) {
        this.callBackMapping[socketType] = callBack
    }
    // 取消某一个回调函数
    unRegisterCallBack(socketType) {
        this.callBackMapping[socketType] = null
    }
    // 发送数据的方法
    send(data) {
        //console.log(data);
        // 判断此时此刻有没有连接成功
        // 连接服务器也需时间，如果先执行发送数据的函数就会报错，用重发机制解决
        //console.log(this.connection);
        if (this.connection == true) {
            // 连接上服务器了，重置发送数据给服务器的次数
            this.sendRetryCount = 0;
            this.ws.send(data)
        } else {
        // 重发数据机制
        // 等待一段时间再次发送
        // 若是服务器关闭，仍然采用500ms重连一次不合适，应该延长多少时间间隔重连一次。这样就不会太浪费时间资源
            this.sendRetryCount++;
            setTimeout(() => {
                //console.log(this.ws)
                this.ws.send(data)
            }, this.sendRetryCount * 500)
        }
    }

    startHeartbeat() {
        this.heartbeatInterval = setInterval(() => {
        if (this.connection) {
            this.ws.send("ping"); // 发送心跳消息
        }
        }, 5000); // 每5秒发送一次心跳
    }

    stopHeartbeat() {
        if (this.heartbeatInterval) {
        clearInterval(this.heartbeatInterval); // 停止心跳检测定时器
        }
    }
}


// WEBPACK FOOTER //
// ./src/utils/websocket.js